<div class="mx-2">
  <div class="detail-card grid">

    <div class="col-12 border-divider sm:col section">
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.OrderIdLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.importOrder.sequence}}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.ProgramIdLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.importOrder.directSaleProgramId}}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.BookingLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.delivery?.booking ? importOrderInformation.delivery?.booking : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
      </div>
    </div>

    <div class="col-12 border-divider sm:col section">
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.ContainerLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.delivery?.containerNumber ? importOrderInformation.delivery?.containerNumber : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.InstructiveLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.delivery?.deliveryInstructions ? importOrderInformation.delivery?.deliveryInstructions : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.ShipLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.delivery?.ship ? importOrderInformation.delivery?.ship : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
      </div>
    </div>

    <div class="col-12 border-divider sm:col section">
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.ImporterLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.importOrder.importer.companyName}}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.OrderCodeLabel' | translate}}</p>
        <p class="p-info">{{getOrderTitle()}}</p>
      </div>
      <div class="row-info">
        <p class="label-info">{{'AdminOrderDetailManagement.Order.OrderDateLabel' | translate}}</p>
        <p class="p-info">{{importOrderInformation.importOrder.created ? (importOrderInformation.importOrder.created | date: 'dd-MM-yyyy') : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
      </div>
    </div>

    <div class="col-12 border-divider sm:col-5 sm:justify-content-center flex justify-content-start">
      <div class="country-section flex flex-row align-content-center justify-content-center gap-4">
        <!-- <div *ngIf="importOrderInformation.importOrder.transportType === 0" class="flex w-4 justify-content-center align-items-center gap-2">
          <img *ngIf="importOrderInformation.departurePort"
            [flag]="importOrderInformation.departurePort.country?.code"
            class="country-img" alt=""/>
          <div class="flex flex-column">
            <span style="font-weight: bolder; font-size: small;">{{importOrderInformation.departurePort?.country | countryDescription}}</span>
            <span style="font-size: smaller;" *ngIf="importOrderInformation.departurePort">{{importOrderInformation.departurePort.name}}</span>
          </div>
          <div *ngIf="!importOrderInformation.departurePort" class="not-country"></div>
          <div class="flex flex-column" *ngIf="!importOrderInformation.departurePort">
            <span style="font-weight: bolder; font-size: small;" *ngIf="!importOrderInformation.departurePort">{{ 'AdminOrderDetailManagement.Order.PendingLabel' | translate }}</span>
            <span style="font-size: smaller;" *ngIf="!importOrderInformation.departurePort">{{ 'AdminOrderDetailManagement.Order.PendingLabel' | translate }}</span>
          </div>
        </div> -->

            <app-location-info
            [type]="importOrderInformation.importOrder.transportType"
            [countryName]="
              importOrderInformation.departurePort?.country?.name ?? 
              importOrderInformation.departureAirport?.country?.name ?? 
              importOrderInformation.departureCity?.country?.name"
            [countryCode]="
              importOrderInformation.departurePort?.country?.code ?? 
              importOrderInformation.departureAirport?.country?.code ?? 
              importOrderInformation.departureCity?.country?.code"
            [airportName]="importOrderInformation.departureAirport?.name"
            [portName]="importOrderInformation.departurePort?.name"
            [cityName]="importOrderInformation.departureCity?.name"
            >
            </app-location-info>

          <div class="flex flex-column justify-content-center align-content-center">
              <app-transport-type-icon
              [type]="importOrderInformation.importOrder.transportType"
              [ship]="importOrderInformation.delivery?.ship">
              </app-transport-type-icon>
            <!-- <div class="flex justify-content-center align-items-center">
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="importOrderInformation.importOrder.transportType === 0">directions_boat</span>
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="importOrderInformation.importOrder.transportType === 1">flight</span>
              <span class="material-symbols-outlined" style="color: #6da043; font-size: 1rem">arrow_forward_ios</span>
            </div>
            <div *ngIf="importOrderInformation?.delivery?.ship" class="flex justify-content-center align-content-center">
              <span class="text-center" style="font-size: small;">{{ importOrderInformation.delivery?.ship }}</span>
            </div> -->
          </div>


          <app-location-info
          [type]="importOrderInformation.importOrder.transportType"
          [countryName]="importOrderInformation.destinationPort?.country?.name ?? importOrderInformation.destinationAirport?.country?.name ?? importOrderInformation.destinationCity?.country?.name"
          [countryCode]="
            importOrderInformation.destinationPort?.country?.code ??
            importOrderInformation.destinationAirport?.country?.code ??
            importOrderInformation.destinationCity?.country?.code"
          [airportName]="importOrderInformation.destinationAirport?.name"
          [portName]="importOrderInformation.destinationPort?.name"
          [cityName]="importOrderInformation.destinationCity?.name"
          [showLocationName]="true"
          >

          </app-location-info>

        <!-- <div *ngIf="importOrderInformation.importOrder.transportType === 0" class="flex w-4 justify-content-center align-items-center gap-2">
          <img *ngIf="importOrderInformation.destinationPort"
            [flag]="importOrderInformation.destinationPort.country?.code"
            class="country-img" alt=""/>
          <div class="flex flex-column">
            <span style="font-weight: bolder; font-size: small;">{{importOrderInformation.destinationPort?.country | countryDescription}}</span>
            <span style="font-size: smaller;" *ngIf="importOrderInformation.destinationPort">{{importOrderInformation.destinationPort.name}}</span>
          </div>
        </div>

        <div *ngIf="importOrderInformation.importOrder.transportType === 1" class="flex w-4 justify-content-center align-items-center gap-2">
          <img *ngIf="importOrderInformation.destinationAirport" [flag]="importOrderInformation.destinationAirport.country?.code"
            class="country-img" alt=""/>
          <div class="flex flex-column">
            <span style="font-weight: bolder; font-size: small;">{{importOrderInformation.destinationAirport?.country | countryDescription}}</span>
            <span style="font-size: smaller;" *ngIf="importOrderInformation.destinationAirport">{{importOrderInformation.destinationAirport.name}}</span>
          </div>
        </div> -->
      </div>
    </div>

  </div>

  <div *ngIf="showDetails && importOrderInformation" class="mt-3 grid">
    <p-table [value]="details" class="custom-table col-12 p-0">
      <ng-template pTemplate="header">
        <tr>
          <th colspan="2">
            <div class="flex justify-content-center align-items-center">
              Producto
            </div>
          </th>
          <th *ngIf="importOrderInformation.importOrder.isClosedSale">
            <div class="flex justify-content-center align-items-center">
              Fecha Embalaje
            </div>
          </th>
          <th *ngIf="!importOrderInformation.importOrder.isClosedSale">
            <div class="flex justify-content-center align-items-center">
              Fecha Cosecha
            </div>
          </th>
          <th>
            <div class="flex justify-content-center align-items-center">
              Frigorífico
            </div>
          </th>
          <th>
            <div class="flex justify-content-center align-items-center">
              Pallets
            </div>
          </th>
          <th>
            <div class="flex justify-content-center align-items-center">
              Exportador
            </div>
          </th>
          <th>
            <div class="flex justify-content-center align-items-center">
              Acciones
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-detail>
        <tr>
          <td>
            <img [src]="detail.varietyUrlIcon | speciesImageUrl"
              class="fruit-img" [alt]="detail.varietyName"/>
          </td>
          <td>
            <div class="flex justify-content-start align-items-center">
              <div class="font-bold">
                <p class="my-0 line-height-1">{{ detail | speciesName }}/</p>
                <p class="my-0">{{ detail.varietyName }}</p>
              </div>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center">
              {{ detail.harvestDate ? (detail.harvestDate | date: 'dd-MM-yyyy') :  ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center">
              {{ detail.fridgeStorageName + " " + detail.fridgeStorageCity + ', ' + (detail.fridgeStorageCountry | countryDescription) }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center">
              {{ detail.palletsQuantity > 0 ? detail.palletsQuantity : 'N.A.'}}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center">
              {{ detail.exporterCompanyName }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center">
              <div class="flex justify-content-start gap-2">
                <p-button icon="pi pi-table" pTooltip="Ver pallets"
                  (onClick)="goToVerifyPallets(detail.id)"
                  styleClass="p-button p-button-secondary"
                  class="custom-table-button"></p-button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
